import Icon from './icon-placeholder.svg';
//Стили
import './ImagePlaceholder.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ImagePlaceholder = function ImagePlaceholder(_ref) {
    var text = _ref.text;
    return /*#__PURE__*/ _jsxs("div", {
        className: 'image-placeholder',
        children: [/*#__PURE__*/ _jsx(Icon, {
                className: "image-placeholder__icon"
            }), text && /*#__PURE__*/ _jsx("span", {
                className: "image-placeholder__text",
                children: text
            })]
    });
};
export default ImagePlaceholder;
